export default "__VITE_ASSET__eKLTfpPe__"